import { Component, Inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface PasswordReauthDialogData {
  email: string;
  errorMessage?: string;
}

@Component({
  selector: 'app-password-reauth-dialog',
  templateUrl: './password-reauth-dialog.component.html',
  styleUrls: ['./password-reauth-dialog.component.scss'],
})
export class PasswordReauthDialogComponent {
  form = this.fb.group({
    password: ['', Validators.required]
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PasswordReauthDialogData,
    private dialogRef: MatDialogRef<PasswordReauthDialogComponent>,
    private fb: FormBuilder
  ) {}

  onSubmit() {
    if (this.form.valid) {
      this.dialogRef.close({ password: this.form.value.password });
    }
  }

  onCancel() {
    this.dialogRef.close();
  }
}
